//Library
import Swal from 'sweetalert2';
import { isMobile } from 'react-device-detect';
//config
import config from '../../config';

const errorAction = (response, getState) => {
    let errorMsg = getState().anueInfoState.errorMsg;
    let msg = ""
    switch (response.data.code) {
        case "00000":
            msg = errorMsg[response.data.code];
            Swal.fire({
                type: 'info',
                text: msg,
                confirmButtonText: "基金標的變更",
                closeOnConfirm: false,
                allowOutsideClick: false
            });
            return true;
        case "01005":
            return true;
        case "01013":
            return true;
        case "07032":
            msg = errorMsg[response.data.code];
            Swal.fire({
                title: "查無可轉換資料",
                text: msg,
                confirmButtonText: "確定",
                closeOnConfirm: false,
                allowOutsideClick: false
            }).then((result) => {
                this.props.history.push("/Purchase");
            });
            return false;
        case "07034":
            let htmlStr = '<p style="text-align: left;">您好：</p><p style="text-align: left;">因您持有的投資組合包含<span style="color:red">《{$0}》</span>，該基金因合併/清算、撤銷核備或其它終止銷售之因素。故目前無法進行單筆加碼交易，若您需要再進行加碼申購，請在營業日下午2:00前在「定期定額」中申請原專案投組的定期定額停止扣款，在停扣申請生效後，即可在<span style="color:red">次一營業日</span>重新選擇新的投資組合。</p><p style="margin-top:20px;text-align:left;">若您仍有其他疑問，歡迎您來信客服信箱cs@anuefund.com.tw，或於營業時間（9:00 ~ 17:30）內致電客服專線02-27208126 按9，由專人為您服務。</p>'
            if (response.data.returnParam !== undefined && response.data.returnParam.length !== 0) {
                for (let i = 0; i <= response.data.returnParam.length - 1; i++) {
                    htmlStr = htmlStr.replace("{$" + i + "}", response.data.returnParam[i]);
                }
            }
            Swal.fire({
                title: "單筆加碼停止交易",
                html: htmlStr,
                confirmButtonText: "確定",
                closeOnConfirm: false,
                allowOutsideClick: false
            });
            return false;
        case "00013":
            return false;
        case "02002":
            msg = errorMsg[response.data.code];
            if (response.data.returnParam !== undefined && response.data.returnParam.length !== 0) {
                for (let i = 0; i <= response.data.returnParam.length - 1; i++) {
                    msg = msg.replace("{$" + i + "}", response.data.returnParam[i]);
                }
            }
            Swal.fire({ type: 'error', text: msg, confirmButtonText: "前往更新", cancelButtonText: "暫不修改", closeOnConfirm: false }).then((result) => {
                if (result.value) {
                    window.location.href = "../../../EC/member/risk-attribute-assessment";
                }
            });
            //window.location.href = "https://www.anuefund.com/EC/Goodday/";
            return false;
        case "98002":
            msg = errorMsg[response.data.code];
            Swal.fire({
                text: msg,
                confirmButtonText: "確定",
                closeOnConfirm: false,
                allowOutsideClick: false,
            }).then((result) => {
                this.props.history.push("/");
            });
            return false;
        case "03018":
            //kyc 不符
            msg = errorMsg[response.data.code];
            Swal.fire({ type: 'error', text: msg, confirmButtonText: "前往更新", cancelButtonText: "暫不修改", closeOnConfirm: false,allowOutsideClick: false }).then((result) => {
                if (result.value) {
                    window.location.href = "../../../EC/member/risk-attribute-assessment";
                }
            });
            //window.location.href = "https://www.anuefund.com/EC/Goodday/";
            return false;
        case "03035":
            //高齡Kyc 3天內
            msg = errorMsg[response.data.code];
            Swal.fire({
                text: msg,
                confirmButtonText: "確定",
                closeOnConfirm: false,
                allowOutsideClick: false,
            }).then((result) => {
                this.props.history.push("/Purchase");
            });
            return false;
        case "03036":
            //高齡警示
            msg = errorMsg[response.data.code];
            Swal.fire({
                title: "提醒您",
                text: msg,
                confirmButtonText: "確定",
            })
            return false;
        case "03034":
            //高齡Kyc不符
            msg = errorMsg[response.data.code];
            Swal.fire({
                text: msg,
                confirmButtonText: "確定",
                closeOnConfirm: false,
                allowOutsideClick: false,
            }).then((result) => {
                this.props.history.push("/Purchase");
            });
            return false;
        default:
            msg = errorMsg[response.data.code];
            if (response.data.returnParam !== undefined && response.data.returnParam.length !== 0) {
                for (let i = 0; i <= response.data.returnParam.length - 1; i++) {
                    msg = msg.replace("{$" + i + "}", response.data.returnParam[i]);
                }
            }
            Swal.fire({ type: 'error', text: msg, });
            return false;
    }
}
const ApiResponse = (response, getState) => {
    if (response.data.code.slice(2, 5) === "000") {
        return true;
    } else {
        return errorAction(response, getState)
    }
}

ApiResponse.displayName = 'ApiResponse';
export default ApiResponse;
